const Faqs = () => {

    // Fetch all faq accordion headings
    let headings = document.querySelectorAll('[data-question]');

    // Loop through each heading
    Array.from(headings).forEach(heading => {

        // Store the corresponding answer to the question heading
        let target = heading.getAttribute('data-question');

        // If this answer exists, proceed
        if (typeof target != "undefined" && target != null) {

            // Add a click event to the heading
            heading.addEventListener('click', () => {

                // Fetch the element containing the answer
                let content = document.querySelector(`[data-answer="${target}"]`);

                // If we have an answer element, proceed
                if (typeof content != "undefined" && content != null) {
                    // Toggle the open/closed state for this accordion item
                    heading.classList.toggle('open');
                    // Toggle the visibility of the content for this question/heading
                    content.classList.toggle('open');
                }

                // Loop through all other FAQS
                Array.from(headings).forEach(otherQuestion => {

                    // Get the data attribute for the question
                    let question = otherQuestion.getAttribute('data-question');

                    // If the question is not the same as the question we have just toggled, proceed
                    if (question !== target) {
                        // Remove the active class from this question
                        otherQuestion.classList.remove('open');
                        // Fetch the corresponding answer
                        let answer = document.querySelector(`[data-answer="${question}"]`);

                        if (typeof answer != "undefined" && answer != null) {
                            // Close the answer of the other FAQ
                            answer.classList.remove('open');
                        }
                    }

                });
            });
        }
    });
}

export default Faqs;
